import { AllServicesCards } from '@/lib/widgets/main-page/all-services/AllServicesCardsWrapper';

import { JoinTheClub } from '@/lib/shared/blocks/JoinTheClub';
import { H1, P3 } from '@/lib/shared/components/Typography';

import cn from 'clsx';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';

import styles from './CompanyAbout.module.scss';

export const CompanyAbout = ({ h1 }: { h1?: string | null }) => {
  const { t } = useTranslation('index', { keyPrefix: 'about' });

  return (
    <div className={styles.aboutTop}>
      <div className={styles.aboutTop_bg_noise} />
      <div className={styles.aboutTop_leaves}>
        <Image
          sizes="(min-width: 1000px) 1474px, 1031px"
          src={'/leaves/image.webp'}
          alt={'leaves'}
          fill
        />
      </div>

      <div className={cn(styles.container, styles.aboutTop_wrapper)}>
        <div className={styles.aboutTop_teamBg} aria-hidden="true">
          <Image
            src={'/images/team-2026-about-desktop.webp'}
            alt={t('teamPhotoAlt')}
            fill
            sizes="(min-width: 996px) 100vw, 1px"
          />
          <div className={styles.aboutTop_teamBgOverlay} />
        </div>
        <div>
          <H1>{h1 || t('title')}</H1>
          <P3 className={styles.aboutTop_text}>{t('description')}</P3>
        </div>
        <div className={styles.aboutTop_teamPhotoMobile}>
          <Image
            src={'/images/team-2026-mobile.webp'}
            alt={t('teamPhotoAlt')}
            fill
            sizes="(max-width: 995px) 100vw, 1px"
          />
        </div>
        <AllServicesCards className={styles.cardsWrapper} />
      </div>
      <div className={styles.aboutTop_joinTheClub}>
        <JoinTheClub
          title={t('missionTitle')}
          description={t('missionDescription')}
          withoutButton
        />
      </div>
    </div>
  );
};
